import { Component } from '@angular/core';

@Component({
	selector: 'app-reservation-accomodation-service',
	templateUrl: './reservation-accomodation-service.component.html',
	styleUrls: ['./reservation-accomodation-service.component.scss'],
})
export class ReservationAccomodationServiceComponent {
	constructor() {}
}
